import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onBeforeMount } from 'vue';
import { useRouter } from "vue-router/composables";
import store from "@/store";
import BackArrow from "@/assets/icons/short-back-arrow.svg";
import BaseSwitch from "@/components-UI/BaseSwitch.vue";
import BaseModal from "@/components-UI/modals/BaseModal.vue";
import ActionButton from "@/components-UI/buttons/ActionButton.vue";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import BaseButton from "@/components-UI/BaseButton.vue";
import SvgAttention from "@/assets/icons/attention-symbol.svg";
import SvgCheck from "@/assets/icons/check.svg";
import { useWindowResize } from "@/utils/useWindowSize";
import SvgCopy from "@/assets/icons/copy2.svg";
import { useCopyText } from "@/utils/copyText";
import { change2FaStatus, get2FaData } from "@/api/user";
import { showNotification, showServerError } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const router = useRouter();
const userData = computed(() => store.getters['authModule/GET_USER'] ?? {});
const authStatus = ref(false);

const inputValue = ref('');
const isShowDeleteModal = ref(false);
const isShowAddModal = ref(false);
const resultStatusCode = ref(null);
const twoFaData = ref();
const showSwitch = ref(true);

const { width } = useWindowResize();
const isMobile = computed(() => width.value <= 768);


onBeforeMount(() => {
    authStatus.value = store.getters['authModule/GET_TWO_FACTORS_STATUS'];
});

const formatInput = (event) => {
    let value = event.target.value.replace(/\D/g, '');

    if (value.length > 3) {
        value = value.slice(0, 3) + '-' + value.slice(3, 6);
    }

    inputValue.value = value;
};

const validateInput = (event) => {
    if (resultStatusCode.value !== null) {
        resultStatusCode.value = null;
    }

    if ([8, 46, 9, 27, 13].includes(event.keyCode)) {
        return;
    }

    if ((event.ctrlKey || event.metaKey) && [65, 67, 86, 88].includes(event.keyCode)) {
        return;
    }

    if (event.keyCode < 48 || event.keyCode > 57) {
        if (event.keyCode < 96 || event.keyCode > 105) {
            event.preventDefault();
        }
    }
};

const isValid = computed(() => {
    return /^\d{3}-\d{3}$/.test(inputValue.value);
});


const updateTwoFa = async () => {
    if (authStatus.value === true) {
        isShowDeleteModal.value = true;
    } else {
        const resp = await get2FaData();
        twoFaData.value = resp.data;
        authStatus.value = true;
        isShowAddModal.value = true;
    }
};

const turnOnTwoFa = async () => {
    try {
        await change2FaStatus(
            userData.value.id,
            {
                status: true,
                code: inputValue.value.replace('-', ''),
            },
        );
        resultStatusCode.value = true;
        authStatus.value = true;
        store.commit('authModule/SET_TWO_FACTORS_STATUS', true);
    } catch {
        resultStatusCode.value = false;
    }
};

const turnOffTwoFa = async () => {
    try {
        await change2FaStatus(
            userData.value.id,
            {
                status: false,
            },
        );
        authStatus.value = false;
        store.commit('authModule/SET_TWO_FACTORS_STATUS', false);
        showNotification('Двухфакторная аутентификация отключена');
        isShowDeleteModal.value = false;
    } catch {
        showServerError('Не удалось отключить двухфакторную аутентификацию');
    }
};


const closeDeleteModal = () => {
    showSwitch.value = false;
    setTimeout(() => {
        showSwitch.value = true;
    }, 0);

    isShowDeleteModal.value = false;
};

const closeAddModal = () => {
    if (resultStatusCode.value !== true && authStatus.value === true) {
        showSwitch.value = false;
        authStatus.value = false;
        setTimeout(() => {
            showSwitch.value = true;
        }, 0);
    } else {
        resultStatusCode.value = null;
    }

    inputValue.value = '';
    resultStatusCode.value = null;
    isShowAddModal.value = false;
};


function goToApp() {
    window.location.href = twoFaData.value.link;
}

const copyValue = () => {
    useCopyText(twoFaData.value.secret, 'Скопировано');
};

const goBack = () => {
    router.go(-1);
};


return { __sfc: true,router, userData, authStatus, inputValue, isShowDeleteModal, isShowAddModal, resultStatusCode, twoFaData, showSwitch, width, isMobile, formatInput, validateInput, isValid, updateTwoFa, turnOnTwoFa, turnOffTwoFa, closeDeleteModal, closeAddModal, goToApp, copyValue, goBack, BackArrow, BaseSwitch, BaseModal, ActionButton, BaseButtonV2, BaseButton, SvgAttention, SvgCheck, SvgCopy }
}

})